module.exports = __webpack_public_path__ + "static/media/freezvix-1.a7d76f80.jpg";